import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    flex: 2;
    margin: 0 8px;
    text-align: center;
    padding: 6px;
    flex-basis: 26%;
    margin-bottom: 16px;
`;

export const StyledTitle = styled(Typography)`
    margin-bottom: 8px;
    text-align: center;
    color: #204158;
`;
